/**
 * Icônes du menu, dessinées en SVG dans le fichier.
 *
 * Pas de bibliothèque externe : la Content-Security-Policy du CRM interdit de
 * charger quoi que ce soit depuis un autre domaine (voir
 * deploy/nginx-crm-ssl.conf), et une police d'icônes ajouterait 200 Ko pour
 * neuf pictogrammes. Celles-ci héritent de la couleur du texte parent, donc
 * elles s'adaptent d'elles-mêmes à l'état actif ou survolé.
 */
import React from 'react';

const base = {
  width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.8,
  strokeLinecap: 'round', strokeLinejoin: 'round',
};

const Svg = ({ children, taille }) => (
  <svg {...base} width={taille || base.width} height={taille || base.height} aria-hidden="true">
    {children}
  </svg>
);

export const IconeDashboard = (p) => (
  <Svg {...p}><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></Svg>
);

export const IconeEntreprises = (p) => (
  <Svg {...p}><path d="M3 21h18" /><path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 9h2M9 13h2M9 17h2M14 9h2M14 13h2M14 17h2" /></Svg>
);

export const IconeKanban = (p) => (
  <Svg {...p}><rect x="3" y="3" width="5" height="18" rx="1.5" /><rect x="10" y="3" width="5" height="12" rx="1.5" />
    <rect x="17" y="3" width="4" height="16" rx="1.5" /></Svg>
);

export const IconeAgenda = (p) => (
  <Svg {...p}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></Svg>
);

export const IconeProposition = (p) => (
  <Svg {...p}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5M9 13h6M9 17h4" /></Svg>
);

export const IconeDossier = (p) => (
  <Svg {...p}><rect x="4" y="4" width="16" height="17" rx="2" /><path d="M9 2v4M15 2v4M8 11h8M8 15h5" /></Svg>
);

export const IconeDossiers = (p) => (
  <Svg {...p}><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></Svg>
);

export const IconeAdmin = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z" /></Svg>
);

export const IconeClientsWeb = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M3 12h18" />
    <path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18z" /></Svg>
);

export const IconeProfil = (p) => (
  <Svg {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></Svg>
);

export const IconeDeconnexion = (p) => (
  <Svg {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5M21 12H9" /></Svg>
);

export const IconeMenu = (p) => (
  <Svg {...p}><path d="M4 6h16M4 12h16M4 18h16" /></Svg>
);

export const IconeFermer = (p) => (
  <Svg {...p}><path d="M6 6l12 12M18 6L6 18" /></Svg>
);

export const IconeReplier = (p) => (
  <Svg {...p}><path d="M15 18l-6-6 6-6" /></Svg>
);

// ── Actions de liste ────────────────────────────────────────────────────────
// Employées dans les tableaux et les listes, là où le libellé ne tiendrait pas.
// Un « title » est indispensable sur ces boutons : sans texte, l'intention
// n'est lisible qu'au survol.

export const IconeCorbeille = (p) => (
  <Svg {...p}><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" /></Svg>
);

export const IconeCrayon = (p) => (
  <Svg {...p}><path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></Svg>
);
